export default "__VITE_ASSET__C8eT08Lk__"